<aa-view-bar
  [title]="(isEditMode$ | async) ? 'Edit Card' : 'New Card'"
  rightText=""></aa-view-bar>

<div class="customer-view-container v-scrollable">
  @if ((card$ | async)?.label) {
    <h1 class="card-label">{{ (card$ | async)!.label }}</h1>
  }
  <div class="customer-view-sections">
    <div class="section">
      <h2>Images</h2>
      <div class="images">
        <button
          class="add-image-tile"
          [disabled]="aiLoading$ | async"
          [ngStyle]="{
            'background-image': 'url(' + (frontImageDataURL$ | async) + ')'
          }"
          [matMenuTriggerFor]="isNonIOSMobileDevice() ? frontImageMenu : null"
          (click)="isNonIOSMobileDevice() ? null : frontFileUpload.click()">
          <mat-icon>Add</mat-icon>
          <p class="label">Front</p>
          <input
            hidden
            type="file"
            accept="image/*"
            capture="environment"
            #frontFileCapture
            (change)="handleImageUpload($event)" />
          <input
            hidden
            type="file"
            accept="image/*"
            #frontFileUpload
            (change)="handleImageUpload($event)" />
        </button>

        <mat-menu #frontImageMenu="matMenu" class="menu">
          <button mat-flat-button (click)="frontFileCapture.click()">
            <mat-icon iconPositionEnd>photo_camera</mat-icon> Take Photo
          </button>
          <button mat-flat-button (click)="frontFileUpload.click()">
            <mat-icon iconPositionEnd>files</mat-icon> Upload Photo
          </button>
        </mat-menu>

        <button
          class="add-image-tile"
          [disabled]="aiLoading$ | async"
          [ngStyle]="{
            'background-image': 'url(' + (backImageDataURL$ | async) + ')'
          }"
          [matMenuTriggerFor]="isNonIOSMobileDevice() ? backImageMenu : null"
          (click)="isNonIOSMobileDevice() ? null : backFileUpload.click()">
          <mat-icon>Add</mat-icon>
          <p class="label">Back</p>
          <input
            hidden
            type="file"
            accept="image/*"
            capture="environment"
            #backFileCapture
            (change)="handleImageUpload($event, true)" />
          <input
            hidden
            type="file"
            accept="image/*"
            #backFileUpload
            (change)="handleImageUpload($event, true)" />
        </button>

        <mat-menu #backImageMenu="matMenu" class="menu">
          <button mat-flat-button (click)="backFileCapture.click()">
            <mat-icon iconPositionEnd>photo_camera</mat-icon> Take Photo
          </button>
          <button mat-flat-button (click)="backFileUpload.click()">
            <mat-icon iconPositionEnd>files</mat-icon> Upload Photo
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="section">
      <h2>Attributes</h2>
      @if (aiLoading$ | async) {
        <div class="ai-loading">
          <p>Detecting Attributes</p>
          <mat-spinner></mat-spinner>
        </div>
      }
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model">
        </formly-form>
      </form>
    </div>
  </div>
</div>

<div class="customer-view-actions">
  @if (isEditMode$ | async) {
    <button mat-flat-button color="warn" (click)="promptDelete()">
      Delete
    </button>
  } @else {
    <button mat-flat-button color="warn" (click)="cancel()">Cancel</button>
  }
  <button
    mat-flat-button
    color="primary"
    [disabled]="!form.valid"
    (click)="save()">
    Save
  </button>
</div>
